import React from "react";
import {
    Col,
    Container,
} from "reactstrap";



const IXIWORK = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col lg={12}>
                        <div classname="card">
                            <div className="card-body">
                                <h1 className="text-primary text-center">iXiWORK</h1>
                                <h2 className="text-tertiary text-center">Téléchargement APK</h2>
                                <p className="text-muted mb-2 text-center">Application XR utilisateur</p>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-centered table-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Modèle supporté</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Nom</th>
                                                <th scope="col">Version</th>
                                                <th scope="col" style={{ width: "100px" }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>META Quest 3 / 3s</td>
                                                <td>Lecteur XR</td>
                                                <td>iXiWORK-Meta.apk</td>
                                                <td>1.0</td>
                                                <td><button
                                                    title="Télécharger l'APK"
                                                    className="btn btn-sm btn-outline-primary fs-4 py-0 px-1 me-2"
                                                    /*onClick={() => handleDelete(user.user_ID)}*/
                                                    >
                                                    <i className="mdi mdi-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>PICO 4 / Ultra</td>
                                                <td>Lecteur XR</td>
                                                <td>iXiWORK-Pico.apk</td>
                                                <td>1.0</td>
                                                <td>
                                                    <button
                                                        title="Télécharger l'APK"
                                                        className="btn btn-sm btn-outline-primary fs-4 py-0 px-1 me-2"
                                                        onClick={() => {
                                                            const token = localStorage.getItem("token");
                                                            const url = `/api/upload/download-apk/iXiWORK-Meta.apk`;

                                                            // Crée un lien invisible
                                                            const link = document.createElement("a");
                                                            link.href = url;
                                                            link.setAttribute("download", "testixiwork.apk");
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }}
                                                    >
                                                        <i className="mdi mdi-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default IXIWORK;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license